import { GridColumnType } from '@grid'
import dayjs from 'dayjs'

const krw = (value: number | null | undefined): string =>
	value === null || value === undefined
		? ''
		: `₩${Math.round(value).toLocaleString('ko-KR')}`

const money = {
	headerAlign: 'center',
	align: 'right',
	width: 120,
	editable: false,
} as const
const moneyFormatter = (value: number) => krw(value)

/**
 * 정산 연간 탭 — 월별 집계 한 줄(전부 원화, 주문 시점 환율). 마지막 행은 합계(`isTotal`).
 * 월간·주간의 판매 행과 같은 Grid 컴포넌트로 그린다(2026-09-27 사용자 요청). 수정·선택·사이드 패널 없음.
 */
export const settlementYearColumns: GridColumnType = {
	initRow: {},
	fieldToFocus: 'month',
	card: {
		title: 'month',
		subtitle: 'saleTotal',
		meta: ['eligibleCount', 'vatUnpaid', 'donationUnpaid', 'awaitingCount'],
		sections: [
			{ title: '판매', fields: ['eligibleCount', 'saleTotal', 'awaitingCount'] },
			{ title: '부가세', fields: ['vatTotal', 'vatPaid', 'vatUnpaid'] },
			{ title: '후원금', fields: ['donationTotal', 'donationPaid', 'donationUnpaid'] },
			{ title: '기타', fields: ['taxInvoiceCount', 'costMissingCount'] },
		],
	},
	columns: [
		{
			field: 'month',
			headerName: '월',
			headerAlign: 'center',
			width: 80,
			editable: false,
			valueFormatter: (value: string, row: any) =>
				row?.isTotal ? '합계' : value ? dayjs(`${value}-01`).format('M월') : '',
		},
		{
			field: 'eligibleCount',
			headerName: '판매',
			headerAlign: 'center',
			align: 'right',
			width: 90,
			editable: false,
			valueFormatter: (value: number, row: any) =>
				row && row.orderCount !== value
					? `${value} / ${row.orderCount}`
					: String(value ?? ''),
		},
		{
			field: 'saleTotal',
			headerName: '판매 합계',
			...money,
			valueFormatter: moneyFormatter,
		},
		{
			field: 'vatTotal',
			headerName: '부가세 적립',
			...money,
			valueFormatter: moneyFormatter,
		},
		{
			field: 'vatPaid',
			headerName: '부가세 납부',
			...money,
			width: 110,
			valueFormatter: moneyFormatter,
		},
		{
			field: 'vatUnpaid',
			headerName: '부가세 미납',
			...money,
			width: 110,
			valueFormatter: moneyFormatter,
		},
		{
			field: 'donationTotal',
			headerName: '후원금 적립',
			...money,
			valueFormatter: moneyFormatter,
		},
		{
			field: 'donationPaid',
			headerName: '후원금 납부',
			...money,
			width: 110,
			valueFormatter: moneyFormatter,
		},
		{
			field: 'donationUnpaid',
			headerName: '후원금 미납',
			...money,
			width: 110,
			valueFormatter: moneyFormatter,
		},
		{
			field: 'taxInvoiceCount',
			headerName: '세금계산서',
			headerAlign: 'center',
			align: 'right',
			width: 110,
			editable: false,
			valueFormatter: (value: number, row: any) =>
				row
					? `${value ?? 0} / ${row.orderCount - row.awaitingCount}`
					: String(value ?? ''),
		},
		{
			field: 'awaitingCount',
			headerName: '입금 대기',
			headerAlign: 'center',
			align: 'right',
			width: 150,
			editable: false,
			valueFormatter: (value: number, row: any) =>
				value > 0 ? `${value}건 · ${krw(row?.awaitingSale)}` : '0',
		},
		{
			field: 'costMissingCount',
			headerName: '원가 없음',
			headerAlign: 'center',
			align: 'right',
			width: 100,
			editable: false,
			valueFormatter: (value: number) => (value > 0 ? String(value) : ''),
		},
	],
}
